import _styled from "@emotion/styled/base";
function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
import { Button as UIButton } from '../../../../../primitives/index.js';
export const Button = /*#__PURE__*/_styled(UIButton, process.env.NODE_ENV === "production" ? {
  target: "e1ir7why0"
} : {
  target: "e1ir7why0",
  label: "Button"
})(process.env.NODE_ENV === "production" ? {
  name: "1d3w5wq",
  styles: "width:100%"
} : {
  name: "1d3w5wq",
  styles: "width:100%/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkJ1dHRvbi5qcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFFdUMiLCJmaWxlIjoiQnV0dG9uLmpzIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHN0eWxlZCBmcm9tICdAZW1vdGlvbi9zdHlsZWQnO1xuaW1wb3J0IHsgQnV0dG9uIGFzIFVJQnV0dG9uIH0gZnJvbSAnLi4vLi4vLi4vLi4vLi4vcHJpbWl0aXZlcy9pbmRleC5qcyc7XG5leHBvcnQgY29uc3QgQnV0dG9uID0gc3R5bGVkKFVJQnV0dG9uKSBgXG4gIHdpZHRoOiAxMDAlO1xuYDtcbi8vIyBzb3VyY2VNYXBwaW5nVVJMPUJ1dHRvbi5qcy5tYXAiXX0= */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
});